import styles from './BookingSidebarBottomContent.module.scss'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Alert } from 'react-bootstrap'

const BookingSidebarBottomContent = () => {
  return (
    <Container className={styles.root}>
      <Row className={'m-0 mt-5'}>
        <Col>
          {/*<Alert className={'display-linebreak'}>{t('booking.onlineBookingBenefitInfoSidebar')}</Alert>*/}
          <Alert className={'display-linebreak'}>
            <div className={styles.title}>Bei Online-Buchung:</div>
            <ul>
              <li>Bearbeitungsgebühr von 60.- entfällt</li>
              <li>72h kostenloser Reiserücktritt</li>
            </ul>
          </Alert>
        </Col>
      </Row>
    </Container>
  )
}

export default BookingSidebarBottomContent
